// extracted by mini-css-extract-plugin
export default {"container":"Producers_container__bYnIx","search":"Producers_search__tS+Hf"};